/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export var DependencyType;
(function (DependencyType) {
    DependencyType[DependencyType["NONE"] = 0] = "NONE";
    DependencyType[DependencyType["PRIVATE"] = 1] = "PRIVATE";
    DependencyType[DependencyType["SHARED"] = 2] = "SHARED";
    DependencyType[DependencyType["ALL"] = 3] = "ALL";
})(DependencyType || (DependencyType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVwZW5kZW5jeS10eXBlLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZGVwZW5kZW5jeS1pbmplY3Rpb24vdHlwZWQvZGVwZW5kZW5jeS10eXBlLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFFSCxNQUFNLENBQU4sSUFBWSxjQUtYO0FBTEQsV0FBWSxjQUFjO0lBQ3RCLG1EQUFRLENBQUE7SUFDUix5REFBVyxDQUFBO0lBQ1gsdURBQVUsQ0FBQTtJQUNWLGlEQUFPLENBQUE7QUFDWCxDQUFDLEVBTFcsY0FBYyxLQUFkLGNBQWMsUUFLekIifQ==